import classes from 'components/common/bryntumScheduler/components/tooltips/Components/TooltipInfoRow/TooltipInfoRow.module.scss';

interface Props {
    label: string;
    value: string | undefined;
}

export const TooltipInfoRow = ({ label, value }: Props) => {
    if (value == null) return null;
    return (
        <div className={classes.row}>
            <div className={classes.label}>{label}:</div>
            <div className={classes.value}>{value}</div>
        </div>
    );
};
